export const data = {
	"config": {
		"artist":"Huibert van Dorp",
		"aid":"HD",
		"total_pieces":10
	},
	"pieces":[
		{
			"id":"HD_P001",
			"prints":30,
			"title":"Connemara",
			"description":"My grief on the sea, how the waves of it roll: For they have come between me and the love of my soul.",
			"size":"68.00 x 61.00 cm",
      "year": 2009,
      url: require('../assets/maps/7e7e42504804f4a00904c9c92846a585.jpg'),
      thumb: require('../assets/thumbs/7e7e42504804f4a00904c9c92846a585.jpg'),
      tiles: {
        url: '/tiles/HD_P001/',
        prefixUrl: '/openseadragon/images/',
        width: 9449,
        height: 7087,
      }
		},
		{
			"id":"HD_P002",
			"prints":30,
			"title":"De Blauwe Maen",
			"description":"After the overpowering of the Spanish silver fleet by Piet Hein i nthe year 1628, the West Indian Company had enough money to challenge the dominant colonial kingdoms of the Iberian Peninsula.",
			"size":"84.98 x 69.82 cm",
      "year": 2010,
      url: require('../assets/maps/676dde03488437c2c6a18ecb92291e58.jpg'),
      thumb: require('../assets/thumbs/676dde03488437c2c6a18ecb92291e58.jpg'),
      tiles: {
        url: '/tiles/HD_P002/',
        prefixUrl: '/openseadragon/images/',
        width: 11807,
        height: 9701,
      }
		},
		{
			"id":"HD_P003",
			"prints":30,
			"title":"Golf van Mexico",
			"description":"So far we have been lucky enough to reach the harbors at sunrise. It starts with lights in the distance, stars in the sky, a blue light in the east.",
			"size":"83.30 x 64.60 cm",
      "year": 2014,
      url: require('../assets/maps/4d8715abb531ada4bcacf59e0fe30133.jpg'),
      thumb: require('../assets/thumbs/4d8715abb531ada4bcacf59e0fe30133.jpg'),
      tiles: {
        url: '/tiles/HD_P003/',
        prefixUrl: '/openseadragon/images/',
        width: 11605,
        height: 8976,
      }
		},
		{
			"id":"HD_P004",
			"prints":30,
			"title":"Hanjin Genoa",
			"description":"The water is wide, i cannot get over, and neither have i wings to fly. Give me a boat that will cary two, and both shall row, my love and I.",
			"size":"110.79 x 75.88 cm",
      "year": 2012,
      url: require('../assets/maps/3301889a85a7df77f9b4add8e158e589.jpg'),
      thumb: require('../assets/thumbs/3301889a85a7df77f9b4add8e158e589.jpg'),
      tiles: {
        url: '/tiles/HD_P004/',
        prefixUrl: '/openseadragon/images/',
        width: 15395,
        height: 10544,
      }
		},
		{
			"id":"HD_P005",
			"prints":30,
			"title":"Hanjin Palermo Mediterranee",
			"description":"When I go to the toilet in the the middle of the night, i discover that we have reached Europe. Undera moonless night fully of bright stars we sail between the coasts of Spain and Morocco who, far in the dark distance, look like a string of lights.",
			"size":"103.28 x 67.55 cm",
      "year": 2012,
      url: require('../assets/maps/2e2b52f4b4818ff34e00cffdb4814194.jpg'),
      thumb: require('../assets/thumbs/2e2b52f4b4818ff34e00cffdb4814194.jpg'),
      tiles: {
        url: '/tiles/HD_P005/',
        prefixUrl: '/openseadragon/images/',
        width: 14352,
        height: 9386,
      }
		},
		{
			"id":"HD_P006",
			"prints":30,
			"title":"Hanjin Palermo Montreal",
			"description":"Stephen and Marion Kidder picked me up, stayed in the town overnight. went to the Italian market in the morning, even the cabbage looks like a museum piece, sprouts seem like handmade, all in careful arrangement with love and tenderness.",
			"size":"83.43 x 111.16 cm",
      "year": 2012,
      url: require('../assets/maps/75565464968f2b2cd5155d20e77164a2.jpg'),
      thumb: require('../assets/thumbs/75565464968f2b2cd5155d20e77164a2.jpg'),
      tiles: {
        url: '/tiles/HD_P006/',
        prefixUrl: '/openseadragon/images/',
        width: 10092,
        height: 13447,
      }
		},
		{
			"id":"HD_P007",
			"prints":30,
			"title":"Hoek van Holland",
			"description":"It's going to take a while before I have the sea calm again, less coffee would probably also help. Time still goes too fast, it's no longer Saturday, but Sunday, it's not 7 o'clock, but 6. Awoke just in time to sww the cliffs of dover.",
			"size":"83.50 x 64.60 cm",
      "year":2014,
      url: require('../assets/maps/8077b97cc44785736c26699fb82286a3.jpg'),
      thumb: require('../assets/thumbs/8077b97cc44785736c26699fb82286a3.jpg'),
      tiles: {
        url: '/tiles/HD_P007/',
        prefixUrl: '/openseadragon/images/',
        width: 11603,
        height: 8976,
      }
		},
		{
			"id":"HD_P008",
			"prints":30,
			"title":"Las Palmas",
			"description":"Nordic flying fish, spotted on the left side of the bow, Thursday 28.08 at 16:42. Position: N. 29-42-18, W. 12-43-15. Flight approximately 6 meters.",
			"size":"72.44 x 51.00 cm",
      "year": 2008,
      url: require('../assets/maps/a1961f748195a33a8c04977a300ba366.jpg'),
      thumb: require('../assets/thumbs/a1961f748195a33a8c04977a300ba366.jpg'),
      tiles: {
        url: '/tiles/HD_P008/',
        prefixUrl: '/openseadragon/images/',
        width: 10065,
        height: 7087,
      }
		},
		{
			"id":"HD_P009",
			"prints":30,
			"title":"Las Palmas-Carthagena",
			"description": "A classic harbour, a bay surrounded by hills, fortresses and 2500 years of history. On a bleeding hot day we moored 20 minutes walking from the beautiful centre.",
			"size":"103.21 x 73.45 cm",
      "year":2008,
      url: require('../assets/maps/bc63b416fb2a1e79dd1ce0bed14c168d.jpg'),
      thumb: require('../assets/thumbs/bc63b416fb2a1e79dd1ce0bed14c168d.jpg'),
      tiles: {
        url: '/tiles/HD_P009/',
        prefixUrl: '/openseadragon/images/',
        width: 14341,
        height: 10206,
      }
		},
		{
			"id":"HD_P010",
			"prints":30,
			"title":"New Orleans",
			"description":"Sunday, April 3rd 2011. Swanton Vermont. 3 degrees, half seven, sun rises. First cup of coffee outside next to the frozen swimming pool in a back garden the size of half the Malieveld.",
			"size":"93.50 x 66.59 cm",
      "year":2011,
      url: require('../assets/maps/705aeb2baf7d21ae4fae34c271697be9.jpg'),
      thumb: require('../assets/thumbs/705aeb2baf7d21ae4fae34c271697be9.jpg'),
      tiles: {
        url: '/tiles/HD_P010/',
        prefixUrl: '/openseadragon/images/',
        width: 12992,
        height: 9253,
      }
		}	
	]
}


// WEBPACK FOOTER //
// ./src/utils/data.js